var React = require('react');

function ScrolliconInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.41602 5.85731L6.45768 1.66683L11.4994 5.85731M6.45768 1.66683L6.45768 16.3335","stroke":"black","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

ScrolliconInline.defaultProps = {"width":"13","height":"18","viewBox":"0 0 13 18","fill":"none"};

module.exports = ScrolliconInline;

ScrolliconInline.default = ScrolliconInline;
